import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';
import { I18n as I } from 'react-redux-i18n';

import {
  FieldInfo,
  CurrencyInput,
  Dropdown,
  LoaderOverlay,
  PartTypes,
  ControlTypes,
  bind,
  formatCurrency,
  isFunc,
  isNil,
} from 'vdlib';

const inputData = {
  [PartTypes.New]: { color: 'blue', title: I.t('PART_TYPE_NEW') },
  [PartTypes.Used]: { color: 'red', title: I.t('PART_TYPE_USED') },
  [PartTypes.Imitation]: { color: 'yellow', title: I.t('PART_TYPE_IMITATION') },
};

class AuctionBidModal extends React.Component {
  constructor(props) {
    super(props);

    bind(this, ['onHide', 'onSubmit', 'amountChanged', 'populate']);

    this.state = {
      amount: 0,
      usedConditionTypeID: null,
      imitationCategoryID: null,
      comments: '',
      dirty: false,
    };
    this.formContext = {
      updateForm: (fieldName, value) =>
        this.setState({ amount: value, dirty: true }),
    };

    this.formContext = {
      updateForm: (name, value) => {
        if (name === 'amount') this.setState({ amount: value });
        else if (name === 'ImitationCategoryID')
          this.setState({ imitationCategoryID: value });
        else if (name === 'UsedConditionTypeID')
          this.setState({ usedConditionTypeID: value });
        else this.setState({ [name]: value, [`${name}Dirty`]: true });
      },
    };

    this.populate(props);
  }

  componentWillReceiveProps(nextProps) {
    this.populate(nextProps);
  }

  onHide() {
    if (isFunc(this.props.onHide)) this.props.onHide();
  }

  onSubmit() {
    if (this.state.amount === 0) return this.setState({ dirty: true });

    if (isFunc(this.props.onSubmit)) {
      this.props.onSubmit(
        { amount: this.state.amount, partType: this.props.partType },
        this.state.comments,
        this.state.usedConditionTypeID,
        this.state.imitationCategoryID
      );
    }
  }

  populate(props) {
    if (isNil(props)) props = this.props;

    this.setState({
      amount: isNil(props.bid) ? 0 : props.bid.Amount,
      usedConditionTypeID: isNil(props.bid) ? 0 : props.bid.UsedConditionTypeID,
      imitationCategoryID: isNil(props.bid) ? 0 : props.bid.ImitationCategoryID,
      comments: isNil(props.bid) ? '' : props.bid.Comments,
    });
  }

  render() {
    if (this.props.partType == null) return false;

    let data = inputData[this.props.partType.Description],
      hasError = this.state.dirty && this.state.amount === 0;
    return (
      <Modal
        // animation={true}
        // className="fade-scale"
        // show={this.props.show}
        // onHide={this.onHide}
        // dialogClassName="custom-modal"
        // style={{ top: '22%' }}
        onCancel={this.onHide}
        visible={this.props.show}
        title={`${I.t('OFFER_FOR')} ${data.title}`}
        style={{ top: '22%' }}
        footer={[
          <button
            type="button"
            className={`btn btn-primary btn-sm float-right ml-sm ${
              this.props.loading ? 'disabled' : ''
            }`}
            disabled={this.props.loading}
            onClick={this.onSubmit}
          >
            {I.t('SAVE_INPUT')}
          </button>,
          <button
            type="button"
            className={`btn btn-default btn-sm float-right ${
              this.props.loading ? 'disabled' : ''
            }`}
            disabled={this.props.loading}
            onClick={this.onHide}
          >
            {I.t('CANCEL')}
          </button>,
        ]}
      >
        <div>
          <LoaderOverlay loading={this.props.loading} />
          {isNil(this.props.bid) ? (
            false
          ) : (
            <div className="alert alert-warning">
              {I.t('OFFER_ALREADY_FOR')}
              {formatCurrency(this.props.bid.Amount)}
              {I.t('OFFER_WILL_BE_REPLACED')}
            </div>
          )}
          <div className="row form-group">
            <label className="control-label col-2">{I.t('AMOUNT')}</label>
            <div className={`col-10 ${hasError ? 'has-error' : ''}`}>
              <CurrencyInput
                value={this.state.amount}
                field={
                  new FieldInfo(
                    'amount',
                    '',
                    this.state.amount,
                    null,
                    this.formContext,
                    ControlTypes.Currency
                  )
                }
                validationMessage={
                  hasError ? I.t('AMOUNT_GREATER_THAN_ZERO') : ''
                }
              />
            </div>
          </div>
          {this.props.partType.Description === PartTypes.Imitation ? (
            <div className="row form-group">
              <label className="control-label col-2">{I.t('CATEGORY')}</label>
              <Dropdown
                inputClassName="col-10"
                value={this.state.imitationCategoryID}
                field={
                  new FieldInfo(
                    'ImitationCategoryID',
                    'ΚατImitation',
                    null,
                    this.props.imitationCategories,
                    this.formContext,
                    ControlTypes.Dropdown
                  )
                }
                validationMessage={hasError ? '' : ''}
              />
            </div>
          ) : (
            false
          )}
          {this.props.partType.ID === 2 ? (
            <div>
              <div className="row form-group">
                <label className="control-label col-2">{I.t('STATUS')}</label>
                <Dropdown
                  inputClassName="col-10"
                  value={this.state.usedConditionTypeID}
                  field={
                    new FieldInfo(
                      'UsedConditionTypeID',
                      'ΚαταστΜεταχειρ',
                      null,
                      this.props.usedConditionTypes,
                      this.formContext,
                      ControlTypes.Dropdown
                    )
                  }
                  validationMessage={''}
                />
              </div>
              <div className="input-group">
                <span className="input-group-addon">{I.t('PHOTOS')}</span>
                <input type="file" className="form-control" />
                <span className="input-group-btn">
                  <button className="btn btn-secondary" type="button">
                    {I.t('SAVE')}
                  </button>
                </span>
              </div>
              <br />
            </div>
          ) : (
            false
          )}

          <div className="row form-group">
            <label className="control-label col-2">{I.t('COMMENTS')}</label>
            <div className="col-10">
              <textarea
                rows="4"
                className="form-control"
                value={this.state.comments}
                onChange={e => this.setState({ comments: e.target.value })}
              />
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

AuctionBidModal.propTypes = {
  bid: PropTypes.any,
  onCancel: PropTypes.func,
  onHide: PropTypes.func,
  onSubmit: PropTypes.func.isRequired,
  partType: PropTypes.object,
  show: PropTypes.bool,
  usedConditionTypes: PropTypes.object,
  imitationCategories: PropTypes.object,
};

export default AuctionBidModal;
